import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/kk.ts
var add = "қосу";
var remove = "Жою";
var removeAll = "Барлығын жою";
var incomplete = "Кешіріңіз, барлық өрістер дұрыс толтырылмаған.";
var submit = "Жіберу";
var noFiles = "Ешбір файл таңдалмады";
var moveUp = "Жоғары жылжу";
var moveDown = "Төмен жылжытыңыз";
var isLoading = "Жүктеу...";
var loadMore = "Көбірек жүктеңіз";
var next = "Келесі";
var prev = "Алдыңғы";
var addAllValues = "Барлық мәндерді қосыңыз";
var addSelectedValues = "Таңдалған мәндерді қосыңыз";
var removeAllValues = "Барлық мәндерді алып тастаңыз";
var removeSelectedValues = "Таңдалған мәндерді алып тастаңыз";
var chooseDate = "Күнді таңдаңыз";
var changeDate = "Өзгерту күні";
var close = "Жабу";
var open = "Ашық";
var accepted = function({
  name
}) {
  return `қабылдаңыз ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} кейін болуы керек ${date(args[0])}.`;
  }
  return `${sentence(name)} болашақта болуы керек.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} тек алфавиттік таңбаларды қамтуы мүмкін.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} тек әріптер мен сандардан тұруы мүмкін.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} тек әріптер мен бос орындар болуы мүмкін.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} алфавиттік таңбалардан тұруы керек.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} құрамында әріптер немесе сандар болуы керек.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} құрамында әріптер немесе бос орындар болуы керек.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} символы болуы керек.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} құрамында бас әріптер болуы керек.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} кіші әріп болуы керек.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} сандардан тұруы керек.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} символы болуы керек.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} тек бас әріптерден тұруы мүмкін.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} құрамында тек кіші әріптер болуы мүмкін.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} бұрын болуы керек ${date(args[0])}.`;
  }
  return `${sentence(name)} өткенде болуы керек.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Бұл өріс қате конфигурацияланған және оны жіберу мүмкін емес.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} арасында болуы керек ${a} және ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} сәйкес келмейді.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} жарамды күн емес, пішімді пайдаланыңыз ${args[0]}`;
  }
  return "Бұл өріс қате конфигурацияланған және оны жіберу мүмкін емес";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} арасында болуы керек ${date(args[0])} және ${date(args[1])}`;
};
var email = "Өтінеміз қолданыстағы электронды пошта адресін енгізіңіз.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} -мен бітпейді ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} рұқсат етілген мән емес.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} кем дегенде бір таңба болуы керек.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} кем немесе тең болуы керек ${max2} кейіпкерлер.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} ${max2} таңбалары болуы керек.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} артық немесе тең болуы керек ${min2} кейіпкерлер.`;
  }
  return `${sentence(name)} арасында болуы керек ${min2} және ${max2} кейіпкерлер.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} рұқсат етілген мән емес.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `артық болуы мүмкін емес ${args[0]} ${name}.`;
  }
  return `${sentence(name)} кем немесе тең болуы керек ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Файл пішімдері рұқсат етілмейді.";
  }
  return `${sentence(name)} типте болуы керек: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `кем болуы мүмкін емес ${args[0]} ${name}.`;
  }
  return `${sentence(name)} кем дегенде болуы керек ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” рұқсат етілмейді ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} сан болуы керек.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" не ")} қажет.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} талап етіледі.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} -ден басталмайды ${list(args)}.`;
};
var url = function() {
  return `Жарамды URL мекенжайын енгізіңіз.`;
};
var invalidDate = "Таңдалған күн жарамсыз.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var kk_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, kk_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=kk.mjs.map